/* eslint-disable no-underscore-dangle */
/* eslint-disable theme-colors/no-literal-colors */
import { makeSingleton } from '../utils';

class LabelColors {
  private _labelColors: Record<string, string>;

  public set labelColors(value: Record<string, string>) {
    this._labelColors = value;
  }

  public get labelColors() {
    return this._labelColors;
  }
}

const getInstance = makeSingleton(LabelColors);

export default getInstance;
